/**
 * オブジェクトの数え上げ可能なキーを取得する。
 * @param v
 */
export default function getOwnKeys<K extends symbol | string | number>(v: Record<K, unknown>): K[] {
  const descriptors = Object.getOwnPropertyDescriptors(v);
  return [...Object.getOwnPropertySymbols(v), ...Object.getOwnPropertyNames(v)].filter(
    (k) => descriptors[k as keyof typeof v]?.enumerable,
  ) as K[];
}
